module.exports = __webpack_public_path__ + "img/default.105c7551.jpg";